import TwitterIcon from './twitter-icon.svg';

export default TwitterIcon;
